import { CheckCircleIcon } from "@phosphor-icons/react";

import { clsx } from "@alpacahq/ui/old";

import { Spinner } from "../Spinner";

interface ActionButtonsProps {
  onCancel: () => void;
  isSubmitDisabled: boolean;
  isSubmitLoading: boolean;
  isSubmitCompleted?: boolean;
}

export const ActionButtons = ({
  onCancel,
  isSubmitDisabled,
  isSubmitLoading,
  isSubmitCompleted = false,
}: ActionButtonsProps) => {
  const showStatus = isSubmitLoading || isSubmitCompleted;

  return (
    <div className="relative w-full">
      <div
        className={clsx(
          "absolute inset-0 flex min-h-[40px] items-center justify-center rounded bg-[rgba(215,215,215,0.24)] p-2",
          "transition-all duration-200 ease-out",
          showStatus
            ? "scale-100 opacity-100"
            : "pointer-events-none scale-95 opacity-0",
          isSubmitLoading && "cursor-wait",
          isSubmitCompleted && "cursor-default",
        )}
      >
        {isSubmitCompleted ? (
          <div className="flex items-center gap-2">
            <CheckCircleIcon size={20} className="text-emerald-600" />
            <p className="m-0 p-0 font-medium text-emerald-600 text-sm">
              Order Submitted
            </p>
          </div>
        ) : (
          <Spinner />
        )}
      </div>

      <div
        className={clsx(
          "flex w-full items-start justify-end gap-2",
          "transition-all duration-200 ease-out",
          showStatus
            ? "pointer-events-none scale-95 opacity-0"
            : "scale-100 opacity-100",
        )}
      >
        {!showStatus && (
          <button
            type="button"
            onClick={onCancel}
            className={clsx(
              "flex flex-1 items-center justify-center",
              "rounded px-4 py-2",
              "border border-gray-500 bg-transparent",
              "text-center font-medium text-gray-800 text-sm leading-5",
              "hover:border-gray-400 hover:text-gray-600",
              "transition-colors",
            )}
          >
            Cancel
          </button>
        )}
        <button
          type="submit"
          disabled={isSubmitDisabled || isSubmitLoading}
          className={clsx(
            "flex items-center justify-center",
            "rounded px-4 py-2",
            "border-none bg-[#fee546]",
            "text-center font-medium text-gray-950 text-sm leading-5",
            "hover:bg-[#fde020]",
            "disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
            "transition-colors",
            "flex-1",
          )}
        >
          Submit
        </button>
      </div>
    </div>
  );
};
